import type { SiteEntity } from '../../types/site';
import type { GridLedStandbyPlanningInput } from '../../types/gridLedStandbyPlanning';
import { requireDemonstrationSite } from '../demonstration/provenance';
import { effectivePhaseCapacity } from '../projectIntent';
import { resolveSiteStudyArea } from '../siteStudyArea';

/** Visible editable draft only. Known intent fields still require explicit
 * field review; all other inputs start unknown, never with archetype defaults. */
export function createGridLedStandbyPlanningDraft(site: SiteEntity, ownerUid: string): GridLedStandbyPlanningInput {
  const selectionHash = resolveSiteStudyArea(site)?.scope.selectionHash;
  if (!selectionHash) throw new Error('Select a study area before creating a grid-led planning draft.');
  const phases = site.projectIntent?.phases ?? [];
  if (!phases.length) throw new Error('Declare Project Intent phases before grid-led planning.');
  const demo = requireDemonstrationSite(site, ownerUid);
  return {
    schemaVersion: 1, authority: 'user-declared-planning', ownerUid, siteId: site.id,
    studyAreaSelectionHash: selectionHash,
    ...(demo ? { demonstrationScenarioId: demo.scenarioId } : {}),
    phases: [...phases].sort((left, right) => left.sequence - right.sequence).map(phase => ({
      phaseId: phase.id, facilityMW: effectivePhaseCapacity(phase).isExact ? effectivePhaseCapacity(phase).mw : null,
      itMW: null, gridImportMW: null, gridServiceDate: null, operationTargetDate: phase.targetInServiceDate ?? null,
    })),
    standby: { role: 'emergency-standby-and-testing-only', ratingBasis: 'site-net', unitCount: null, siteNetMWPerUnit: null, unavailableUnits: null },
    ups: { dischargeMW: null, usableEnergyMWh: null },
    annual: { itDesignMW: null, itUtilizationPct: null, pue: site.projectIntent?.pueValue ?? null,
      hoursPerYear: null, comparisonPue: null, gridTonnesCo2ePerMWh: null, testLoadPct: null, testHoursPerYear: null,
      testDuty: 'load-bank-no-grid-displacement', litresPerMWh: null, kgCo2ePerLitre: null, emergencyOutageEnergyMWh: null },
    sources: [],
  };
}
